import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { api } from '../../../../singleton/axios';

export interface Watchlist {
  id: string;
  user_id: string;
  name: string;
  created_at: string;
  updated_at: string;
  holdings_count: number;
  holdings: WatchlistHolding[];
}

export interface WatchlistHolding {
  id: string;
  ticker: string;
  created_at: string;
  updated_at: string;
}

async function fetchWatchlists(): Promise<Watchlist[]> {
  const { data } = await api.get<{ data: Watchlist[] }>('/stock-watchlists');
  return data.data;
}

export function useWatchlists() {
  const query = useQuery({
    queryKey: ['watchlists'],
    queryFn: fetchWatchlists,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on authentication errors
      if (error?.message?.includes('401') || error?.message?.includes('403')) {
        return false;
      }
      return failureCount < 3;
    },
  });

  // Handle errors using useEffect pattern
  React.useEffect(() => {
    if (query.error) {
      // Show error notification only for network errors (not auth errors)
      if (!query.error?.message?.includes('401') && !query.error?.message?.includes('403')) {
        enqueueSnackbar('Failed to load watchlists', {
          variant: 'error',
          autoHideDuration: 5000,
        });
      }
    }
  }, [query.error]);

  return query;
}